import { validIsp, sortIsps } from './utils';
import * as types from '../../actions/types';

export default (state = {}, action) => {
  switch(action.type) {
    case types.LOCATION_LOADING:
      return { ...state, [action.location_id]: {
        isLoading: true,
        isError: false
      }};
    case types.RECEIVE_LOCATION:
      return { ...state, [action.location_id]: {
        isLoading: false,
        isError: false,
        location: action.location.location,
        isps: sortIsps(action.location.isps.filter(isp => validIsp(isp))),
        shard: action.shard
      }}
    case types.LOCATION_LOADING_ERROR:
      return { ...state, [action.location_id]: {
        isLoading: false,
        isError: true,
        shard: action.shard
      }}
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/locations.js